import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FiscalDatePipe } from './fiscal-date.pipe';
import { FixedNumberPipe } from './fixed-number.pipe';
import { XenaDatePipe } from './xena-date.pipe';



@NgModule({
  declarations: [FiscalDatePipe, FixedNumberPipe, XenaDatePipe],
  imports: [
    CommonModule
  ],
  providers: [
    DatePipe
  ],
  exports: [
    FiscalDatePipe,
    FixedNumberPipe,
    XenaDatePipe
  ]
})
export class PipesModule { }
